export const FILE_FORMATS = ['xlsx'];

export const [DEFAULT_FILE_FORMAT] = FILE_FORMATS;

export const FILE_CONTENT_TYPE = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const FREQUENCY = ['daily', 'weekly', 'monthly'];
export const [DEFAULT_FREQUENCY] = FREQUENCY;
export const FREQUENCY_TRANSLATIONS = {
  daily: 'reports.frequency.daily',
  weekly: 'reports.frequency.weekly',
  monthly: 'reports.frequency.monthly',
};

// Used to determine which selectors to display
export const CONDITIONAL_FREQUENCY = {
  daily: FREQUENCY[0],
  weekly: FREQUENCY[1],
  monthly: FREQUENCY[2],
};

export const TIME = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
];
export const [DEFAULT_TIME] = TIME;
export const TIME_TRANSLATIONS = {
  '00:00': 'reports.time.00:00',
  '00:30': 'reports.time.00:30',
  '01:00': 'reports.time.01:00',
  '01:30': 'reports.time.01:30',
  '02:00': 'reports.time.02:00',
  '02:30': 'reports.time.02:30',
  '03:00': 'reports.time.03:00',
  '03:30': 'reports.time.03:30',
  '04:00': 'reports.time.04:00',
  '04:30': 'reports.time.04:30',
  '05:00': 'reports.time.05:00',
  '05:30': 'reports.time.05:30',
  '06:00': 'reports.time.06:00',
  '06:30': 'reports.time.06:30',
  '07:00': 'reports.time.07:00',
  '07:30': 'reports.time.07:30',
  '08:00': 'reports.time.08:00',
  '08:30': 'reports.time.08:30',
  '09:00': 'reports.time.09:00',
  '09:30': 'reports.time.09:30',
  '10:00': 'reports.time.10:00',
  '10:30': 'reports.time.10:30',
  '11:00': 'reports.time.11:00',
  '11:30': 'reports.time.11:30',
  '12:00': 'reports.time.12:00',
  '12:30': 'reports.time.12:30',
  '13:00': 'reports.time.13:00',
  '13:30': 'reports.time.13:30',
  '14:00': 'reports.time.14:00',
  '14:30': 'reports.time.14:30',
  '15:00': 'reports.time.15:00',
  '15:30': 'reports.time.15:30',
  '16:00': 'reports.time.16:00',
  '16:30': 'reports.time.16:30',
  '17:00': 'reports.time.17:00',
  '17:30': 'reports.time.17:30',
  '18:00': 'reports.time.18:00',
  '18:30': 'reports.time.18:30',
  '19:00': 'reports.time.19:00',
  '19:30': 'reports.time.19:30',
  '20:00': 'reports.time.20:00',
  '20:30': 'reports.time.20:30',
  '21:00': 'reports.time.21:00',
  '21:30': 'reports.time.21:30',
  '22:00': 'reports.time.22:00',
  '22:30': 'reports.time.22:30',
  '23:00': 'reports.time.23:00',
  '23:30': 'reports.time.23:30',
};

export const DAY_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export const [DEFAULT_DAY_OF_WEEK] = DAY_OF_WEEK;
export const DAY_OF_WEEK_TRANSLATIONS = {
  monday: 'reports.days.monday',
  tuesday: 'reports.days.tuesday',
  wednesday: 'reports.days.wednesday',
  thursday: 'reports.days.thursday',
  friday: 'reports.days.friday',
  saturday: 'reports.days.saturday',
  sunday: 'reports.days.sunday',
};
export const DAY_OF_WEEK_CRON = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 0,
};

export const DAY_OF_MONTH = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
];
export const [DEFAULT_DAY_OF_MONTH] = DAY_OF_MONTH;
